/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface FeuillePresenceSearch
 */
export interface FeuillePresenceSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof FeuillePresenceSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FeuillePresenceSearch
     */
    codeClasse?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FeuillePresenceSearch
     */
    anneeAcademique?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof FeuillePresenceSearch
     */
    withHoraire?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof FeuillePresenceSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FeuillePresenceSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FeuillePresenceSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeuillePresenceSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FeuillePresenceSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FeuillePresenceSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FeuillePresenceSearch interface.
 */
export function instanceOfFeuillePresenceSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FeuillePresenceSearchFromJSON(json: any): FeuillePresenceSearch {
    return FeuillePresenceSearchFromJSONTyped(json, false);
}

export function FeuillePresenceSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeuillePresenceSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'codeClasse': !exists(json, 'codeClasse') ? undefined : TextSearchFromJSON(json['codeClasse']),
        'anneeAcademique': !exists(json, 'anneeAcademique') ? undefined : TextSearchFromJSON(json['anneeAcademique']),
        'withHoraire': !exists(json, 'withHoraire') ? undefined : BooleanSearchFromJSON(json['withHoraire']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FeuillePresenceSearchToJSON(value?: FeuillePresenceSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': TextSearchToJSON(value.nom),
        'codeClasse': TextSearchToJSON(value.codeClasse),
        'anneeAcademique': TextSearchToJSON(value.anneeAcademique),
        'withHoraire': BooleanSearchToJSON(value.withHoraire),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

